import { Bar, BarChart, XAxis, YAxis, Tooltip, ResponsiveContainer, Cell } from "recharts";
import { Card } from "../../../../components/ui/card";
import { ScrollArea } from "../../../../components/ui/scroll-area";
import type { DoctorWorkloadData } from "../../../../shared/schema";

interface DoctorWorkloadChartProps {
  data: DoctorWorkloadData[];
  title?: string;
}

export function DoctorWorkloadChart({ data, title = "Khối lượng công việc theo bác sĩ" }: DoctorWorkloadChartProps) {
  const displayData = data.slice(0, 10);
  const chartHeight = Math.max(280, displayData.length * 45);

  return (
    <Card className="p-6 border border-card-border">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-base font-semibold text-foreground">{title}</h3>
        <span className="text-xs text-muted-foreground">Tuần này</span>
      </div>
      <ScrollArea className="h-[320px]">
        <div style={{ height: chartHeight, minHeight: 280 }}>
          <ResponsiveContainer width="100%" height="100%">
            <BarChart 
              data={displayData} 
              layout="vertical" 
              margin={{ top: 0, right: 40, left: 0, bottom: 0 }}
            >
              <XAxis 
                type="number"
                axisLine={false}
                tickLine={false}
                tick={{ fontSize: 11, fill: "hsl(var(--muted-foreground))" }}
              />
              <YAxis 
                type="category"
                dataKey="doctorName"
                width={130}
                axisLine={false}
                tickLine={false}
                tick={{ fontSize: 11, fill: "hsl(var(--foreground))" }}
              />
              <Tooltip
                content={({ active, payload }) => {
                  if (!active || !payload || !payload.length) return null;
                  const item = payload[0].payload as DoctorWorkloadData;
                  return (
                    <div className="bg-popover border border-popover-border rounded-lg px-3 py-2 shadow-lg">
                      <p className="text-sm font-medium text-foreground">{item.doctorName}</p>
                      <p className="text-xs text-muted-foreground">{item.specialty}</p>
                      <p className="text-sm text-muted-foreground mt-1">
                        {item.appointments} lịch hẹn
                      </p>
                    </div>
                  );
                }}
              />
              <Bar dataKey="appointments" radius={[0, 4, 4, 0]} maxBarSize={30}>
                {displayData.map((_, index) => (
                  <Cell 
                    key={`cell-${index}`}
                    fill={index === 0 ? "hsl(var(--primary))" : "hsl(var(--chart-2))"}
                  />
                ))}
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        </div>
      </ScrollArea>
    </Card>
  );
}
